import React from 'react';

// The floating emoji layer. Each reaction drifts up and fades out on its own
// CSS animation and is removed from state by the timer in useMeetingSignals -
// this component renders whatever is currently alive and nothing more.
//
// Horizontal placement is derived from the reaction's own id rather than
// Math.random() at render time: a random left offset would be recomputed on
// every re-render (a new speaker, a camera toggle) and the emoji would jump
// sideways mid-flight.
function offsetFor(id) {
    let hash = 0;
    for (let i = 0; i < id.length; i++) hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
    return 8 + (hash % 70); // keep clear of both edges
}

export default function MeetingReactions({ reactions }) {
    if (reactions.length === 0) return null;
    return (
        <div className="MeetReactionLayer" aria-hidden="true">
            {reactions.map((reaction) => (
                <span key={reaction.id} className="MeetFloatingReaction" style={{ left: `${offsetFor(reaction.id)}%` }}>
                    <span className="MeetFloatingEmoji">{reaction.emoji}</span>
                    <span className="MeetFloatingName">{reaction.name}</span>
                </span>
            ))}
        </div>
    );
}
